import type { GlobalWishlist2 } from '~/amplienceTypes/schemas/imported/global-wishlist-schema';
import { WISHLIST_ITEMS_VARIABLE } from '~/utilities/constants/amplienceVariables';

interface Params {
  content?: GlobalWishlist2;
  wishlistAmount: number;
}

interface ReturnType {
  wishlistAriaLabel: string;
}

export function getWishlistAriaLabel({ content, wishlistAmount }: Params): ReturnType {
  const contentString =
    content?.wishlistIconAccessibilityLabels?.itemsInWishlist ||
    `Items in wishlist: ${WISHLIST_ITEMS_VARIABLE}`;

  return {
    wishlistAriaLabel: contentString.replace(WISHLIST_ITEMS_VARIABLE, wishlistAmount.toString()),
  };
}
